<template>
  <div
    class="view-simulators-chat container"
    :class="{ fullscreen: !!this.$route.params.slug }"
  >
    <div class="position-relative">
      <iframe
        :src="`https://api.m60.com.br/v1/chatproxy?code=${code}`"
        class="w-100 py-0 my-0"
        frameborder="0"
      ></iframe>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    code: String
  }
};
</script>

<style lang="scss" scoped>
.view-simulators-chat {
  &.fullscreen {
    padding-top: 81px;
  }

  iframe {
    height: 75vh;
  }
}
</style>
